<template>

</template>

<script>
import { createApp } from "vue";
import Toast from "vue-toastification";

createApp().use(Toast, {
    transition: "Vue-Toastification__fade",
    containerClassName: "alert-container",
});

import { useToast } from "vue-toastification";
import "vue-toastification/dist/index.css";

export default {
    props: ['alert_queue'],
    alert_queue(){
        return{
            toast: null
        }
    },
    data(){
        return{
            position: 'top-center'
        }
    },
    mounted(){
        this.toast = useToast();
    },
    watch:{
          'alert_queue': {
            handler(){
                const alert = this.alert_queue[this.alert_queue.length - 1];
                if(alert.position){ //override position if needed
                    this.position = alert.position;
                }

                this.toast(alert.text, { timeout: 2500 ,  
                position: this.position, 
                type: alert.type, 
                toastClassName: "my-custom-toast-class",
                hideProgressBar: true,
                icon: false,
                closeButton: false
            });
            },
            deep: true
        }
    }
}
</script>

<style lang='scss'>
    .Vue-Toastification__toast--success.my-custom-toast-class {
        background-color: #343a40;
        // border: solid 1px var(--primary-colour-2);
        // border: solid 1px var(--primary-colour-2);
        border-radius: 12px;
        text-align: center;
        // color: var(--primary-colour-2);
        // font-weight: 600;
    }
    .Vue-Toastification__toast--error.my-custom-toast-class {
        // background-color: #D0342C;
        background-color: #be3144;
        border-radius: 12px;
        // border-radius: 0px;
        text-align: center;
    }

    .Vue-Toastification__container.bottom-right.alert-container{
        // margin-bottom: var(--footer-height);

        @media (max-width: 768px) { 
            padding-left: 30px;
            padding-right: 30px;
        }
    }

</style>